import Api from '../utilities/api';
import {
  triggerIdA, triggerIdU
} from './apiConfig';
import TriskeleScreens from './TriskeleScreens';

export default class RecommendationAccess {
  static getRecommendationsCalendar = (startDate, endDate, clientId) => Api.post('_Rcmndtn_RcmndtnCalendar', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.recommendation.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'ClientID',
        value: clientId
      },
      {
        name: 'StartDate',
        value: startDate
      },
      {
        name: 'EndDate',
        value: endDate
      },
      {
        name: 'isVisible',
        value: 1
      }
    ]
  });

  static getRecommendationDetails = (clientId, recommendationOccurenceId) => Api.post('_Rcmndtn_RcmndtnDetails', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.recommendation.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'ClientID',
        value: clientId
      },
      {
        name: 'RcmndtnOccurncId',
        value: recommendationOccurenceId
      },
      {
        name: 'isVisible',
        value: 1
      }
    ]
  });

  static getListOfRecommendations = clientId => Api.post('_Rcmndtn_ListOfRcmndtns', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.recommendation.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'ClientID',
        value: clientId
      },
      {
        name: 'isVisible',
        value: 1
      }
    ]
  });

  static editOccurence = (clientId, occurenceId, qtyDescrptrQtyUnit) => Api.post('_Rcmndtn_EditRcmndtnOccurnc', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.recommendation.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdU
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'ClientID',
        value: clientId
      },
      {
        name: 'PrcsParmtrName',
        value: 'Action'
      },
      {
        name: 'PrcsParmtrValueOne',
        value: 'Modified'
      },
      {
        name: 'PrcsParmtrValueTwo',
        value: 'NA'
      },
      {
        name: 'RcmndtnOccurncCount',
        value: '1 of 1'
      },
      {
        name: 'RcmndtnOccurncId',
        value: occurenceId
      },
      {
        name: 'QtyDescrptr_Qty_UnitIdArray',
        value: qtyDescrptrQtyUnit
      }
    ]
  });

  static editSeries = (clientId, recommendationSeriesId, qtyDescrptrQtyUnit) => Api.post('_Rcmndtn_EditRcmndtnSeries', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.recommendation.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdU
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'ClientID',
        value: clientId
      },
      {
        name: 'PrcsParmtrName',
        value: 'Action'
      },
      {
        name: 'PrcsParmtrValueOne',
        value: 'Modified'
      },
      {
        name: 'PrcsParmtrValueTwo',
        value: 'NA'
      },
      {
        name: 'RcmndtnSeriesCount',
        value: '1 of 1'
      },
      {
        name: 'RcmndtnSeriesId',
        value: recommendationSeriesId
      },
      {
        name: 'QtyDescrptr_Qty_UnitIdArray',
        value: qtyDescrptrQtyUnit
      }
    ]
  });

  static deleteOccurence = (clientId, recommendationOccurenceId) => Api.post('_Rcmndtn_DeleteRcmndtnOccurnc', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.recommendation.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'ClientID',
        value: clientId
      },
      {
        name: 'PrcsParmtrName',
        value: 'Action'
      },
      {
        name: 'PrcsParmtrValueOne',
        value: 'Deleted'
      },
      {
        name: 'PrcsParmtrValueTwo',
        value: 'NA'
      },
      {
        name: 'RcmndtnOccurncCount',
        value: '1 of 1'
      },
      {
        name: 'RcmndtnOccurncId',
        value: recommendationOccurenceId
      }
    ]
  });

  static deleteSeries = (clientId, recommendationSeriesId) => Api.post('_Rcmndtn_DeleteRcmndtnSeries', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.recommendation.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdU
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'ClientID',
        value: clientId
      },
      {
        name: 'PrcsParmtrName',
        value: 'Action'
      },
      {
        name: 'PrcsParmtrValueOne',
        value: 'Deleted'
      },
      {
        name: 'PrcsParmtrValueTwo',
        value: 'NA'
      },
      {
        name: 'RcmndtnSeriesCount',
        value: '1 of 1'
      },
      {
        name: 'RcmndtnSeriesId',
        value: recommendationSeriesId
      }
    ]
  });

  static restoreOccurence = (clientId, occurenceId) => Api.post('_Rcmndtn_RstrRcmndtnOccurnc', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.recommendation.ScreenId

      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'ClientID',
        value: clientId
      },
      {
        name: 'RcmndtnOccurncId',
        value: occurenceId
      },
      {
        name: 'isVisible',
        value: 1
      }
    ]
  });

  static confirmRecommendations = (type, clientId, data, count) => Api.post('_Rcmndtn_CnfmRcmndtns_Master', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.recommendation.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'ClientID',
        value: clientId
      },
      {
        name: 'PrcsParmtrName',
        value: 'Action'
      },
      {
        name: 'PrcsParmtrValueOne',
        value: type
      },
      {
        name: 'PrcsParmtrValueTwo',
        value: 'NA'
      },
      {
        name: 'RcmndtnSeriesAddedCount',
        value: type === 'Added' ? count : 'NA'
      },
      {
        name: 'RcmndtnAddedArray',
        value: type === 'Added' ? data : 'NA'
      },
      {
        name: 'RcmndtnSeriesModifiedCount',
        value: type === 'Modified' ? count : 'NA'
      },
      {
        name: 'RcmndtnModifiedArray',
        value: type === 'Modified' ? data : 'NA'
      },
      {
        name: 'RcmndtnSeriesDeletedCount',
        value: type === 'Deleted' ? count : 'NA'
      },
      {
        name: 'RcmndtnDeletedArray',
        value: type === 'Deleted' ? data : 'NA'
      }
    ]
  })
}
